import {
  constants as loadConstants,
  validators as loadValidators,
} from 'utils/loads';

import { isEmpty } from 'utils/types';

const validateLoad = ({
  load,
  settings,
  validations,
  orderType,
  onlyDirty,
}) => {
  const errors = Object.values(loadConstants.FIELDS).reduce((acc, fieldKey) => {
    const value = load[fieldKey];
    if (onlyDirty && typeof value === 'undefined') {
      return acc;
    }
    const { error } = loadValidators.validateLoadInput({
      field: fieldKey,
      value,
      settings,
      orderType,
      load,
      validations,
    });

    return error ? { ...acc, [error]: error } : { ...acc };
  }, {});
  return {
    isValid: isEmpty(errors) && Object.keys(errors) <= 0,
    errors,
  };
};

export default validateLoad;
